/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';

import BurgerMenu from './components/BurgerMenu';
import DeleteButton from './components/DeleteButton';
import TextSearch from './components/TextSearch';
import SynonymWordsSyncButton from './components/SynonymWordsSyncButton';

const Components = {
    BurgerMenu,
    DeleteButton,
    TextSearch,
    SynonymWordsSyncButton,
};

if (window._bolReactRenderQueue) {
    window._bolReactRenderQueue.forEach(fn => fn(React, ReactDOM, Components));
}



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/register-components.js